<template>
    <div>
        <v-card flat>
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Print Receipt </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-btn v-if="learner_receipt_data != null" id="wv_btn" class="ma-2 no-display" tile outlined color="warning"
                @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            <v-row class="main" id="document1">
                <v-col cols="12" sm="6" md="6" class="m-0 p-0">
                    <v-card>
                        <v-simple-table dense class="elevation-1 table-container">
                            <template v-slot:default>
                                <thead>
                                    <tr v-bind="org_basic_data != ''">
                                        <td colspan="3">
                                            <v-row dense justify="center"
                                                v-if="org_basic_data.trust_logo != '' || org_basic_data.trust_logo != null">
                                                <v-col cols="12" md="2" sm="2">
                                                    <center>
                                                        <img v-if="org_basic_data.trust_logo != '--'"
                                                            :src="org_basic_data.trust_logo" class="trust-logo"
                                                            alt="logo" />
                                                    </center>
                                                </v-col>
                                                <v-col cols="12" md="10" sm="10" class="line-height">
                                                    <center>
                                                        <div v-if="org_basic_data.trust_name"><b>{{
                                                            org_basic_data.trust_name }}</b></div>
                                                        <div v-if="org_basic_data.school_name"><b>{{
                                                            org_basic_data.school_name }} </b></div>
                                                        <div v-if="org_basic_data.address">{{ org_basic_data.address
                                                            }}</div>
                                                        <div v-if="org_basic_data.phone"> Phone : {{
                                                            org_basic_data.phone }}</div>
                                                        <div v-if="org_basic_data.email">Email : {{
                                                            org_basic_data.email }}</div>
                                                        <div v-if="org_basic_data.website"></div>Website : {{
                                                            org_basic_data.website }}
                                                    </center>
                                                </v-col>
                                            </v-row>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left line-height" colspan="3">
                                            <div style="display: flex; justify-content: space-between;">
                                                <span><b>Receipt No.: {{ learner_receipt_data.receipt_no }}</b></span>
                                                <span><b> Receipt Date : {{ learner_receipt_data.receipt_date
                                                        }}</b></span>
                                            </div>




                                            <div class="text-left">
                                                <strong>
                                                    Reg No. : {{ learner_receipt_data.registration_number }}
                                                </strong>
                                            </div>
                                            <div class="text-left">
                                                <strong>
                                                    Student Name : {{ learner_receipt_data.name }}
                                                </strong>
                                            </div>
                                            <div class="text-left">
                                                <strong> Class - Section : {{ learner_receipt_data.standard }} {{
                                                    learner_receipt_data.division
                                                    }}</strong>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="1"><strong>Fee Type</strong></td>
                                        <td><strong> Fee Amount (Rs.)</strong></td>
                                        <td><strong> Refundable</strong></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in learner_receipt_data.student_receipt_details" :key="item.id">
                                        <td colspan="1">
                                            {{ item.component }}
                                        </td>
                                        <td>{{ item.amount }}</td>
                                        <td>{{ item.is_nonrefundable }}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td colspan="3" class="line-height">
                                        <div class="text-left" v-if="learner_receipt_data.discount_amount">
                                            <strong> Discount Amount :</strong>
                                            Rs. {{ learner_receipt_data.discount_amount }}
                                        </div>
                                        <div v-if="learner_receipt_data.fine > 0" class="text-left">
                                            <strong> Late Fee Charge :</strong>
                                            Rs.{{ learner_receipt_data.fine }}
                                        </div>
                                        <div class="text-left">
                                            <strong> Total Receipt Amount :</strong>
                                            Rs.{{ learner_receipt_data.total_fees_amount }}
                                        </div>
                                        <div class="text-left">
                                            <strong> Amount In Words :</strong>
                                            {{ learner_receipt_data.amount_in_words }}
                                        </div>
                                        <div class="text-left">

                                            <strong> Payment Mode : </strong>
                                            {{ learner_receipt_data.payment_mode }}
                                        </div>
                                        <div class="text-left" v-if="learner_receipt_data.payment_mode != 'Online'">
                                            <strong> Payment Details:</strong>
                                            {{ learner_receipt_data.remark }}
                                        </div>
                                        <div v-if="learner_receipt_data.payment_mode != 'Cash'" class="text-left">
                                            <strong> DD / Cheque / Transaction No.:</strong>
                                            {{ learner_receipt_data.trnx_id }}
                                        </div>
                                        <div v-if="learner_receipt_data.payment_mode != 'Cash'" class="text-left">
                                            <strong> DD / Cheque / Transaction Date:</strong>
                                            {{ learner_receipt_data.transaction_date }}
                                        </div>
                                        <div v-if="learner_receipt_data.payment_mode != 'Cash'" class="text-left">
                                            <strong> Bank Name:</strong>
                                            {{ learner_receipt_data.bank_name }}
                                        </div>
                                        <div class="text-left" v-if="learner_receipt_data.payment_mode != 'Cash'">
                                            <strong> Branch Name :</strong>
                                            {{ learner_receipt_data.branch_name }}
                                        </div>
                                        <div
                                            v-if="valid_without_signature == 'true' || valid_without_signature == true">
                                        </div>
                                        <div v-else>
                                            <v-row>
                                                <v-col cols="12" sm="5" md="5"> </v-col>
                                                <v-col cols="12" sm="7" md="7">
                                                    <span style="position: absolute; right: 50px;"><strong>{{
                                                            org_basic_data.school_name }}
                                                        </strong></span>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <div class="text-left"
                                            v-if="valid_without_signature == 'true' || valid_without_signature == true">
                                            <br><br>
                                            <strong> Note: This
                                                receipt is generated
                                                electronically and is valid without a signature.</strong>

                                        </div>
                                        <div v-else>
                                            <br />
                                            <br />
                                            <span
                                                style="position: absolute; bottom: 40px; right: 120px;"><strong>Signature</strong></span>
                                        </div>

                                        <div class="text-left">
                                            * Fees once paid is not refundable/ non-transferable.
                                            <br />
                                            * Cheques/ECS/ Online payment are subject to realization.
                                            <br />
                                            * Bouncing of Cheques/ ECS will fetch penalty.
                                            <br />
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            overlay: false,
            learner_receipt_data: null,
            valid_without_signature: false,

            radios: null,
            receipt_no: null,
            registration_no: null,
            ay: null,
            org_basic_data: [],
        };
    },
    watch: {
        receipt_no() {
            this.getData();
        },

        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    created() {
        this.receipt_no = JSON.parse(this.$session.get("receipt_no"));
        this.ay = JSON.parse(this.$session.get("ay"));
        this.registration_no = JSON.parse(this.$session.get("registration_no"));
    },
    mounted() {
        this.getData();

    },
    methods: {
        print() {
            const oldTitle = document.title;
            document.title = `eps-school`;
            var content = document.getElementById("document1").innerHTML;
            var mywindow = document.body.innerHTML;
            document.body.innerHTML = content;
            window.print();
            document.body.innerHTML = mywindow;
            location.reload();
            return true;
        },
        convert(number) {
            var converter = require("number-to-words");
            const string = converter.toWords(number);
            const string1 = string.charAt(0).toUpperCase() + string.slice(1);
            return string1;
        },
        getData() {
            this.overlay = true;
            this.learner_receipt_data = null;
            const formData = {
                receipt_no: this.receipt_no,
                registration_no: this.registration_no,
                ay: this.ay,
            };
            axios
                .post("/AccountingAndFeesReports/getFeeReceipts", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.learner_receipt_data = res.data.student_receipt_details;
                        this.org_basic_data = res.data.org_basic_data;
                        this.valid_without_signature = res.data.valid_without_signature;
                        this.overlay = false;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.overlay = false;
                        return;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                    this.overlay = false;
                })
                .finally(() => {
                    //close loader
                    this.overlay = false;
                });
        },
    },
};
</script>
<style scoped>
.text-left {
    text-align: left;
}

@media all and (max-width: 900px) {
    .padding-bot {
        padding: 8px;
    }
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
    }

    body,
    tr,
    th,
    td {
        font-size: xx-large !important;
    }

    tbody {
        line-height: 160% !important;
    }

    .line-height {
        line-height: 150% !important;
    }

    .text-left {
        text-align: left;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .trust-logo {
        /* width: 170% !important; */
        width: 150% !important;
    }

    @page {
        size: A4;
        margin-top: none;
        padding-top: none;
        size: 25in 20in;
    }

    table,
    td,
    tr,
    th {
        text-align: center !important;
        margin-top: none;
        padding: 1rem !important;
        font-size: xx-large !important;
        /* font-weight: bold !important; */
        border-bottom: 1px solid black;
        border: 1px solid black;
    }

    .main {
        margin-top: -90px !important;
    }
}

.table-container {
    overflow-x: hidden;
    overflow: hidden;
}

.text {
    color: red !important;
    font-size: bold !important;
}

.trust-logo {
    width: 120%;
}
</style>
